import { ChangeEvent } from 'react';
import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq, debounce } from 'lodash';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { locateValue } from '@tool/index';

const moIndustryEffect = observable({
  type: 'chart', // chart, table
  empty: false,
  staffCount: <number | string>'',
  timeActive: <number | string>'',
  arr: <any[]>[],
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  maxStaff: 0,
  overview: <any[]>[],
  timer: <any>null,
});

const industryEffectInit = action(async (res: any) => {
  if (isEmpty(res) || isEmpty(res.chart_data)) {
    moIndustryEffect.empty = true;
    return;
  }
  moIndustryEffect.empty = false;
  const titles: any[] = [];
  let max = 0;
  const tableArr: any[] = [];

  // res.chart_data.map((item: any) => titles.push(item.category));
  res.chart_data[0].data?.map((child: any) => {
    titles.push(child.label);
  });
  titles.unshift('职能');
  res.chart_data.map((item: any) => {
    item.data.map((child: any) => {
      if (child.count > max) max = child.count;
    });
  });
  res.chart_data.map((item: any) => {
    const tempArr: any[] = [];
    tempArr.push(item.category);
    item.data.map((child: any) => {
      if (child.count > 0) tempArr.push(`${locateValue(child.count)}人`);
      else tempArr.push('-');
    });
    tableArr.push(tempArr);
  });

  moIndustryEffect.arr = res.chart_data;
  moIndustryEffect.tableTitle = titles;
  moIndustryEffect.maxStaff = max;
  moIndustryEffect.overview = res.overview;
  moIndustryEffect.tableList = tableArr;
});

const changeType = action((value: string) => {
  moIndustryEffect.type = value;
  localStorage.setItem('effectIndustrySupport', value);
});

// 切换年份
const supportTimeChange = action(async (value: number | string, change?:boolean) => {
  runInAction(() => {
    moIndustryEffect.timeActive = value;
  });
  localStorage.setItem('supportIndustryEffectYear', value.toString());
  if (change) return ;
  toggleValue('isLoading', true);
  setTimeout(() => {
    toggleValue('isLoading', false);
  }, 10000);
  const res: any = await EffectService.supportMultiIndustry({
    year: value,
    staff_num: moIndustryEffect.staffCount,
  });
  if (isEmpty(res) || isEmpty(res.chart_data)) {
    toggleValue('isLoading', false);
  }
  await industryEffectInit(res);
  toggleValue('isLoading', false);
});

const changeValue = action(async (ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
  const value = ev.target.value;
  const regRxp = /^[0-9]*$/;
  if (regRxp.test(value)) {
    moIndustryEffect.staffCount = value;

    moIndustryEffect.timer = setTimeout(() => {
      clearTimeout(moIndustryEffect.timer);
      toggleValue('isLoading', true);
      EffectService.supportMultiIndustry({
        year: moIndustryEffect.timeActive,
        staff_num: moIndustryEffect.staffCount,
      }).then((res: any) => {
        industryEffectInit(res);
        toggleValue('isLoading', false);
      });
    }, 500);
  }
});

const changeStaff = action((val: number | string) => {
  moIndustryEffect.staffCount = val;
});

export default moIndustryEffect;
export {
  industryEffectInit, changeType, supportTimeChange,
  changeValue, changeStaff,
};
